import * as React from 'react'
import { DsTypography, DsTypographyProps } from '@am92/react-design-system'

import { T_DYNAMIC_STRING } from '~/src/Types/StaticPage.Types'

export interface IDynamicStringProps extends DsTypographyProps {
  dynamicString: T_DYNAMIC_STRING[]
}

export function DynamicString(props: IDynamicStringProps) {
  const { dynamicString, ...restProps } = props

  return (
    <DsTypography
      variant='headingBoldLarge'
      textAlign={{ xs: 'center', md: 'left' }}
      {...restProps}
      sx={{
        width: { xs: '100%', md: '50%' },
        ...restProps?.sx
      }}
    >
      {dynamicString.map((item, index) => {
        const JSX = []

        if (item.newLine) {
          JSX.push(<br key={`${index}-br`} />)
        }

        if (item.color) {
          JSX.push(
            <DsTypography
              key={index}
              component='span'
              variant='inherit'
              sx={{ color: 'var(--ds-colour-actionSecondary)' }}
            >
              {item.label}{' '}
            </DsTypography>
          )
        } else {
          JSX.push(
            <DsTypography key={index} component='span' variant='inherit'>
              {item.label}{' '}
            </DsTypography>
          )
        }

        return JSX
      })}
    </DsTypography>
  )
}
